import React from 'react'
import { FormattedMessage } from 'react-intl';
import downloadIcon from "./img/download-icon.png";
import { useStateMachine } from 'little-state-machine';
import { updateAction } from 'scenes/ProjectMultiStepForm/store';

const Step3Description = () => {
  const { state, actions } = useStateMachine({ updateAction });

  const openDownloadFormats = () => {
    actions.updateAction({
      ...state,
      showDownloadFormatsModal: true,
    });
  };

  return (
    <p>
      <FormattedMessage
        id="ProjectStepForm.step3.description"
        defaultMessage="Para que tu proyecto pueda publicarse y usarse en marketing, necesitas una autorización previa. {br} Solicítala a tu cliente usando los siguientes formatos: <u>Descarga aqui los formatos</u>"
        values={{
          br: <br />,
          u: (...chunks) => (
            <u
              onClick={openDownloadFormats}
              className="font-weight-bold orange-text cursor-pointer"
            >
              {chunks}
              <img
                src={downloadIcon}
                alt="download-icon"
                width={13}
                height={13}
                className="ml-1 download-formats--icon"
              />
            </u>
          ),
        }}
      />
    </p>
  );
}

export default Step3Description